//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../no/ScCollector.js";
import "../CAM/CAM.BlankIpwSetList.js";
import "../no/ScCollector.js";
import "../no/ObjectList.js";
let d=[[[1,"AdditionalGeometryCollector",0,"ScCollector",0],[1,"SetList",0,"CAM.BlankIpwSetList",0]],[[[],"Update",{R_:{status:''}},0,0],[[],"CreateBlankIpwSet",{R_:{blankIpwSet:"CAM.BlankIpwSet"}},0,0],[[],"GetStatus",{R_:{status:''}},0,0]],[]];
SPLM.CAM.BlankIpwMultipleSource = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.BlankIpwMultipleSource";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.BlankIpwMultipleSource.StatusTypes = Object.freeze({
    "UpToDate" : "UpToDate", "OutOfDate" : "OutOfDate", "UnableToUpdate" : "UnableToUpdate", "None" : "None", "Unknown" : "Unknown"});

export default SPLM;